import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.438 4.813a.561.561 0 1 1 1.125 0V7.7l1.999 1.331a.543.543 0 0 1 .136.78.516.516 0 0 1-.76.137l-2.25-1.5c-.157-.085-.25-.26-.25-.47zM8 2a6 6 0 1 1 0 12A6 6 0 1 1 8 2M3.125 8A4.874 4.874 0 0 0 8 12.875 4.874 4.874 0 0 0 12.875 8 4.874 4.874 0 0 0 8 3.125 4.874 4.874 0 0 0 3.125 8"
    }, null, -1)
  ]))]))
}
export default { render: render }